export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  createdAt: string;
  imageCount: number;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  cover: string;
  description: string;
  category: string;
  categorySlug: string;
  tags: string[];
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  favorites: number;
  updatedAt: string;
  chapters: ComicChapter[];
  isHot: boolean;
  isNew: boolean;
  isRecommended: boolean;
}

export const categories = [
  { name: '恋爱', slug: 'romance', icon: 'ri-heart-line' },
  { name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line' },
  { name: '动作', slug: 'action', icon: 'ri-sword-line' },
  { name: '悬疑', slug: 'mystery', icon: 'ri-search-eye-line' },
  { name: '搞笑', slug: 'comedy', icon: 'ri-emotion-laugh-line' },
  { name: '日常', slug: 'slice-of-life', icon: 'ri-calendar-line' },
  { name: '剧情', slug: 'drama', icon: 'ri-movie-line' },
  { name: '热血', slug: 'shonen', icon: 'ri-fire-line' },
];

export const comics: Comic[] = [
  {
    id: 'comic-01',
    title: '霸道总裁的契约新娘',
    author: '金智慧',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20webtoon%20style%20illustration%20of%20a%20CEO%20man%20in%20a%20sharp%20black%20suit%20and%20a%20bride%20woman%20in%20a%20flowing%20white%20wedding%20dress%20standing%20back%20to%20back%2C%20modern%20city%20skyline%20in%20soft%20blurred%20background%2C%20dramatic%20lighting%2C%20soft%20pastel%20color%20palette%2C%20clean%20illustration%20style%20with%20smooth%20linework%2C%20romantic%20atmosphere&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    description: '一场意外让平凡女孩林小凡成为了冷血总裁的契约新娘。原本以为只是一场交易，却没想到冰山总裁的心里藏着不为人知的秘密。当真相一点点浮出水面，她该何去何从？经典霸道总裁恋爱故事，每一话都让人心动不已。',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['总裁', '契约婚姻', '甜宠', '都市'],
    status: '连载中',
    rating: 9.5,
    views: 1280000,
    favorites: 35600,
    updatedAt: '2026-08-04',
    chapters: Array.from({ length: 87 }, (_, i) => ({
      id: `ch-01-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      createdAt: new Date(2026, 0, 1 + i * 3).toISOString().split('T')[0],
      imageCount: 45 + Math.floor(Math.random() * 20),
    })),
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 'comic-02',
    title: '重生之逆天改命',
    author: '朴志勋',
    cover: 'https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20webtoon%20style%20illustration%20of%20a%20warrior%20girl%20with%20flowing%20dark%20hair%20wielding%20a%20glowing%20sword%2C%20dramatic%20dynamic%20pose%2C%20magical%20particles%20floating%20around%2C%20ancient%20palace%20ruins%20in%20the%20misty%20background%2C%20warm%20golden%20and%20crimson%20color%20scheme%2C%20clean%20illustration%20with%20smooth%20linework&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    description: '被最信任的人背叛后，天才剑士凌霜重生回到了十年前。带着前世的记忆和遗憾，她发誓要改变一切，让那些伤害过她的人付出代价。这一世，她要站在世界的巅峰！燃爆热血的逆袭之路就此开启。',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['重生', '逆袭', '战斗', '女性向'],
    status: '连载中',
    rating: 9.7,
    views: 2560000,
    favorites: 89200,
    updatedAt: '2026-08-03',
    chapters: Array.from({ length: 124 }, (_, i) => ({
      id: `ch-02-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      createdAt: new Date(2025, 6, 1 + i * 3).toISOString().split('T')[0],
      imageCount: 42 + Math.floor(Math.random() * 22),
    })),
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 'comic-03',
    title: '暗夜追踪者',
    author: '李东旭',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20and%20moody%20Korean%20webtoon%20style%20illustration%20of%20a%20detective%20man%20in%20a%20long%20black%20coat%20standing%20under%20a%20streetlamp%20in%20the%20rain%2C%20noir%20atmosphere%2C%20neon%20reflections%20on%20wet%20pavement%2C%20mysterious%20silhouette%20in%20the%20distance%2C%20cool%20blue%20and%20deep%20orange%20color%20contrast%2C%20cinematic%20composition&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    description: '城市中接连发生的离奇案件让刑警韩哲陷入了一场巨大的阴谋之中。每一个线索都指向一个神秘组织，而真相远比想象中更加恐怖。在这场追逐中，他不仅要面对穷凶极恶的罪犯，还要直面自己内心最深的恐惧。',
    category: '悬疑',
    categorySlug: 'mystery',
    tags: ['刑侦', '悬疑', '推理', '都市'],
    status: '连载中',
    rating: 9.3,
    views: 980000,
    favorites: 42100,
    updatedAt: '2026-08-02',
    chapters: Array.from({ length: 56 }, (_, i) => ({
      id: `ch-03-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      createdAt: new Date(2025, 10, 1 + i * 4).toISOString().split('T')[0],
      imageCount: 48 + Math.floor(Math.random() * 18),
    })),
    isHot: true,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 'comic-04',
    title: '我的室友是九尾狐',
    author: '崔美英',
    cover: 'https://readdy.ai/api/search-image?query=A%20charming%20Korean%20webtoon%20style%20illustration%20of%20a%20young%20woman%20with%20nine%20translucent%20fox%20tails%20behind%20her%20and%20fox%20ears%2C%20wearing%20modern%20casual%20clothes%2C%20standing%20in%20a%20cozy%20apartment%20living%20room%2C%20warm%20evening%20sunlight%20streaming%20through%20the%20window%2C%20soft%20and%20dreamy%20atmosphere%2C%20pink%20and%20cream%20color%20palette&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    description: '平凡大二学生苏小暖在租房子时意外发现新室友竟然是一只修炼千年的九尾狐！本以为会遇到各种妖魔鬼怪，结果这位九尾狐大人除了长得帅之外，还是个家务满分、厨艺超群的暖男。人与妖的奇妙同居生活就此展开~',
    category: '搞笑',
    categorySlug: 'comedy',
    tags: ['奇幻', '搞笑', '同居', '甜宠'],
    status: '连载中',
    rating: 9.4,
    views: 1520000,
    favorites: 67800,
    updatedAt: '2026-08-04',
    chapters: Array.from({ length: 72 }, (_, i) => ({
      id: `ch-04-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      createdAt: new Date(2025, 8, 1 + i * 3).toISOString().split('T')[0],
      imageCount: 38 + Math.floor(Math.random() * 15),
    })),
    isHot: false,
    isNew: true,
    isRecommended: true,
  },
  {
    id: 'comic-05',
    title: '剑与魔法学院',
    author: '郑宇成',
    cover: 'https://readdy.ai/api/search-image?query=A%20fantasy%20Korean%20webtoon%20style%20illustration%20of%20a%20group%20of%20young%20students%20in%20magical%20academy%20uniforms%20standing%20in%20front%20of%20a%20grand%20castle-like%20school%20building%2C%20holding%20various%20magical%20weapons%2C%20sparkling%20magical%20effects%2C%20bright%20daytime%20setting%2C%20vibrant%20and%20colorful%20illustration%20style%2C%20adventure%20atmosphere&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    description: '在剑与魔法学院里，每个学生都在为成为最强的魔法剑士而努力。平凡少年陈星在入学第一天就被测出拥有传说中的"混沌魔力"，从此他的校园生活彻底改变。友情、热血、成长，一部不容错过的奇幻校园大作！',
    category: '热血',
    categorySlug: 'shonen',
    tags: ['学院', '魔法', '战斗', '友情'],
    status: '连载中',
    rating: 9.6,
    views: 1890000,
    favorites: 74500,
    updatedAt: '2026-08-03',
    chapters: Array.from({ length: 98 }, (_, i) => ({
      id: `ch-05-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      createdAt: new Date(2025, 4, 1 + i * 3).toISOString().split('T')[0],
      imageCount: 40 + Math.floor(Math.random() * 20),
    })),
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 'comic-06',
    title: '咖啡店的小确幸',
    author: '尹秀雅',
    cover: 'https://readdy.ai/api/search-image?query=A%20heartwarming%20Korean%20webtoon%20style%20illustration%20of%20a%20young%20barista%20woman%20smiling%20while%20serving%20coffee%20in%20a%20cozy%20small%20cafe%2C%20warm%20interior%20with%20wooden%20furniture%2C%20plants%20by%20the%20window%2C%20soft%20afternoon%20sunlight%2C%20relaxed%20and%20peaceful%20atmosphere%2C%20warm%20beige%20and%20brown%20tones&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    description: '厌倦了996生活的白领周可可辞职后，用全部积蓄在街角开了一家小小的咖啡店。这里没有商场的喧嚣，只有咖啡的香气和温暖的人情。每天都有不同的顾客带来不同的故事，而咖啡店也慢慢成为了这条街上最温暖的地方。',
    category: '日常',
    categorySlug: 'slice-of-life',
    tags: ['治愈', '咖啡', '日常', '温暖'],
    status: '已完结',
    rating: 9.1,
    views: 670000,
    favorites: 31200,
    updatedAt: '2026-07-28',
    chapters: Array.from({ length: 45 }, (_, i) => ({
      id: `ch-06-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      createdAt: new Date(2025, 2, 1 + i * 5).toISOString().split('T')[0],
      imageCount: 35 + Math.floor(Math.random() * 12),
    })),
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 'comic-07',
    title: '史上最强废柴',
    author: '韩俊昊',
    cover: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Korean%20webtoon%20style%20illustration%20of%20a%20seemingly%20ordinary%20young%20man%20with%20hidden%20immense%20power%20aura%20surging%20from%20his%20body%2C%20his%20casual%20clothes%20contrasting%20with%20the%20overwhelming%20energy%2C%20cracked%20ground%20beneath%20his%20feet%2C%20dramatic%20wind%20effects%2C%20intense%20expression%2C%20action-packed%20composition%2C%20fiery%20orange%20and%20dark%20tones&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    description: '在一个人人都拥有超能力的世界里，主角赵无锋被检测出"零级"能力，成为全校的笑柄。然而在一次意外中，他发现自己真正的能力是被封印的远古之力。当他觉醒的那一刻，整个世界都将为之震撼！',
    category: '动作',
    categorySlug: 'action',
    tags: ['超能力', '打脸', '爽文', '校园'],
    status: '连载中',
    rating: 9.2,
    views: 1340000,
    favorites: 52300,
    updatedAt: '2026-08-03',
    chapters: Array.from({ length: 68 }, (_, i) => ({
      id: `ch-07-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      createdAt: new Date(2025, 9, 1 + i * 4).toISOString().split('T')[0],
      imageCount: 43 + Math.floor(Math.random() * 19),
    })),
    isHot: true,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 'comic-08',
    title: '泡沫之恋',
    author: '张美兰',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20webtoon%20style%20illustration%20of%20a%20couple%20holding%20hands%20walking%20through%20cherry%20blossom%20trees%20in%20full%20bloom%2C%20soft%20pink%20petals%20falling%20all%20around%2C%20spring%20sunlight%20filtering%20through%20the%20branches%2C%20dreamy%20and%20ethereal%20atmosphere%2C%20gentle%20pastel%20color%20palette%2C%20clean%20and%20delicate%20linework&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    description: '从小青梅竹马的两个人，在高中毕业的那个夏天终于表明了彼此的心意。然而命运却跟他们开了一个残酷的玩笑——双方家庭的反对、异地的距离、误会的累积……他们的爱情像泡沫一样美丽又易碎。一部让人笑着笑着就哭了的纯爱故事。',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['纯爱', '青梅竹马', '青春', '虐心'],
    status: '已完结',
    rating: 9.0,
    views: 890000,
    favorites: 38900,
    updatedAt: '2026-06-15',
    chapters: Array.from({ length: 52 }, (_, i) => ({
      id: `ch-08-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      createdAt: new Date(2024, 8, 1 + i * 5).toISOString().split('T')[0],
      imageCount: 36 + Math.floor(Math.random() * 14),
    })),
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 'comic-09',
    title: '鬼医传',
    author: '崔泰俊',
    cover: 'https://readdy.ai/api/search-image?query=A%20mysterious%20Korean%20webtoon%20style%20illustration%20of%20an%20ancient%20doctor%20with%20long%20white%20hair%20holding%20a%20glowing%20acupuncture%20needle%2C%20surrounded%20by%20floating%20herbs%20and%20ancient%20medical%20scrolls%2C%20traditional%20eastern%20palace%20in%20background%2C%20mystical%20green%20and%20gold%20color%20palette%2C%20elegant%20and%20refined%20atmosphere&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    description: '被誉为"鬼医"的神秘医者穿越到现代都市，用他高超的医术拯救了无数濒死之人。但在救人无数之后，他却发现自己的到来并非偶然，一场跨越千年的阴谋正在等着他揭开。古今交织的医疗奇幻大作！',
    category: '剧情',
    categorySlug: 'drama',
    tags: ['医生', '穿越', '中医', '悬疑'],
    status: '连载中',
    rating: 9.5,
    views: 1120000,
    favorites: 48700,
    updatedAt: '2026-08-04',
    chapters: Array.from({ length: 81 }, (_, i) => ({
      id: `ch-09-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      createdAt: new Date(2025, 3, 1 + i * 3).toISOString().split('T')[0],
      imageCount: 41 + Math.floor(Math.random() * 17),
    })),
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
  {
    id: 'comic-10',
    title: '邻居家的完美男友',
    author: '刘敏静',
    cover: 'https://readdy.ai/api/search-image?query=A%20sweet%20Korean%20webtoon%20style%20illustration%20of%20a%20handsome%20young%20man%20leaning%20against%20the%20doorframe%20of%20an%20apartment%20door%20smiling%20warmly%2C%20holding%20a%20small%20gift%20box%2C%20cozy%20apartment%20hallway%20with%20warm%20lighting%2C%20modern%20and%20clean%20setting%2C%20romantic%20and%20heart-fluttering%20atmosphere&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    description: '刚搬到新住处的设计师安可可在电梯里撞上了一个超级帅哥，结果发现对方就住在隔壁！而且这位邻居不仅长得帅，还特别热心——帮忙修水管、半夜送感冒药、甚至帮她怼走了前任渣男。但是，这么完美的邻居背后是不是藏着什么秘密呢？',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['邻居', '甜宠', '秘密', '都市'],
    status: '连载中',
    rating: 9.3,
    views: 1050000,
    favorites: 46200,
    updatedAt: '2026-08-03',
    chapters: Array.from({ length: 64 }, (_, i) => ({
      id: `ch-10-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      createdAt: new Date(2025, 11, 1 + i * 3).toISOString().split('T')[0],
      imageCount: 39 + Math.floor(Math.random() * 16),
    })),
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
  {
    id: 'comic-11',
    title: '深渊之主',
    author: '金泰亨',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20Korean%20webtoon%20style%20illustration%20of%20a%20demonic%20king%20figure%20on%20a%20black%20throne%20surrounded%20by%20purple%20flames%2C%20wearing%20ornate%20dark%20armor%20with%20crimson%20accents%2C%20intimidating%20presence%2C%20gothic%20castle%20interior%2C%20dramatic%20lighting%20from%20below%2C%20epic%20and%20dark%20atmosphere&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    description: '被流放到深渊的王子，在绝望中获得了深渊之主的力量。十年后，他以绝世强者的姿态归来，向曾经背叛他的皇室复仇。但当他一步步接近真相时，才发现当年的流放背后隐藏着更加可怕的秘密……',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['复仇', '黑暗', '王子', '战斗'],
    status: '连载中',
    rating: 9.4,
    views: 1760000,
    favorites: 68100,
    updatedAt: '2026-08-01',
    chapters: Array.from({ length: 93 }, (_, i) => ({
      id: `ch-11-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      createdAt: new Date(2025, 1, 1 + i * 3).toISOString().split('T')[0],
      imageCount: 44 + Math.floor(Math.random() * 21),
    })),
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 'comic-12',
    title: '打工人的逆袭日记',
    author: '孙志浩',
    cover: 'https://readdy.ai/api/search-image?query=A%20humorous%20Korean%20webtoon%20style%20illustration%20of%20an%20office%20worker%20man%20in%20a%20suit%20with%20a%20determined%20expression%2C%20holding%20a%20resignation%20letter%20while%20walking%20out%20of%20a%20corporate%20office%20building%2C%20bright%20sunlight%20outside%2C%20birds%20flying%20in%20the%20sky%2C%20comical%20and%20uplifting%20atmosphere%2C%20clean%20and%20expressive%20style&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    description: '被公司压榨了三年的社畜李明浩终于在一个周五的下午爆发了——他当众把辞职信甩在了老板脸上。没想到这一幕被路人拍下后在网上爆红，从此他的人生彻底改变。一部让所有打工人笑着笑着就热血沸腾的漫画！',
    category: '搞笑',
    categorySlug: 'comedy',
    tags: ['职场', '搞笑', '逆袭', '治愈'],
    status: '连载中',
    rating: 9.0,
    views: 760000,
    favorites: 34500,
    updatedAt: '2026-08-04',
    chapters: Array.from({ length: 48 }, (_, i) => ({
      id: `ch-12-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      createdAt: new Date(2025, 10, 1 + i * 4).toISOString().split('T')[0],
      imageCount: 37 + Math.floor(Math.random() * 14),
    })),
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
  {
    id: 'comic-13',
    title: '月亮下的约定',
    author: '金多英',
    cover: 'https://readdy.ai/api/search-image?query=A%20melancholic%20Korean%20webtoon%20style%20illustration%20of%20a%20young%20woman%20standing%20alone%20under%20a%20bright%20full%20moon%20on%20a%20hilltop%2C%20looking%20at%20the%20starry%20night%20sky%2C%20gentle%20wind%20blowing%20her%20hair%20and%20dress%2C%20distant%20city%20lights%20below%2C%20emotional%20and%20bittersweet%20atmosphere%2C%20soft%20silver%20and%20indigo%20tones&width=600&height=800&seq=comic-cover-13&orientation=portrait',
    description: '身患罕见疾病的少女苏月在病房里认识了同病相怜的少年江辰。两人约定要一起看到下一个月圆之夜，但这个简单的愿望却变得越来越遥远。一部关于生命、勇气和最纯粹感情的催泪作品，请备好纸巾。',
    category: '剧情',
    categorySlug: 'drama',
    tags: ['催泪', '绝症', '纯爱', '治愈'],
    status: '已完结',
    rating: 9.8,
    views: 2130000,
    favorites: 95600,
    updatedAt: '2026-07-20',
    chapters: Array.from({ length: 36 }, (_, i) => ({
      id: `ch-13-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      createdAt: new Date(2024, 10, 1 + i * 7).toISOString().split('T')[0],
      imageCount: 33 + Math.floor(Math.random() * 10),
    })),
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 'comic-14',
    title: '星际猎人',
    author: '朴俊赫',
    cover: 'https://readdy.ai/api/search-image?query=A%20sci-fi%20Korean%20webtoon%20style%20illustration%20of%20a%20bounty%20hunter%20in%20futuristic%20armor%20holding%20a%20high-tech%20rifle%2C%20standing%20on%20an%20alien%20planet%20with%20two%20moons%20in%20the%20sky%2C%20neon-lit%20spaceship%20in%20the%20distance%2C%20desert%20alien%20landscape%2C%20action%20pose%2C%20vibrant%20color%20palette&width=600&height=800&seq=comic-cover-14&orientation=portrait',
    description: '在遥远的未来，人类已经遍布银河系。赏金猎人雷恩接受了一项看似普通的任务，却发现目标背后牵扯着一个足以毁灭整个星系的巨大阴谋。太空追逐、星际战争、未知文明——一场跨越星海的冒险开始了！',
    category: '动作',
    categorySlug: 'action',
    tags: ['科幻', '星际', '冒险', '战斗'],
    status: '连载中',
    rating: 9.1,
    views: 820000,
    favorites: 29800,
    updatedAt: '2026-08-02',
    chapters: Array.from({ length: 55 }, (_, i) => ({
      id: `ch-14-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      createdAt: new Date(2025, 7, 1 + i * 4).toISOString().split('T')[0],
      imageCount: 46 + Math.floor(Math.random() * 18),
    })),
    isHot: false,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 'comic-15',
    title: '小厨娘的美食日记',
    author: '吴恩熙',
    cover: 'https://readdy.ai/api/search-image?query=A%20delightful%20Korean%20webtoon%20style%20illustration%20of%20a%20young%20female%20cook%20in%20a%20cozy%20kitchen%2C%20happily%20presenting%20a%20beautifully%20plated%20dish%20with%20steam%20rising%2C%20surrounded%20by%20fresh%20ingredients%20and%20cooking%20utensils%2C%20warm%20homey%20atmosphere%2C%20soft%20warm%20lighting%2C%20appetizing%20food%20illustration&width=600&height=800&seq=comic-cover-15&orientation=portrait',
    description: '从烹饪学校毕业的方小雅继承了奶奶留下的老字号小餐馆。在这个被快餐文化冲击的时代，她坚持用最传统的手艺做最地道的家常菜。每一道菜背后都有一个温暖的故事，每一话都能让你隔着屏幕闻到香味~',
    category: '日常',
    categorySlug: 'slice-of-life',
    tags: ['美食', '治愈', '日常', '传统'],
    status: '连载中',
    rating: 9.2,
    views: 590000,
    favorites: 26700,
    updatedAt: '2026-08-03',
    chapters: Array.from({ length: 41 }, (_, i) => ({
      id: `ch-15-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      createdAt: new Date(2025, 5, 1 + i * 5).toISOString().split('T')[0],
      imageCount: 34 + Math.floor(Math.random() * 11),
    })),
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 'comic-16',
    title: '魔女的条件',
    author: '郑惠珍',
    cover: 'https://readdy.ai/api/search-image?query=A%20mysterious%20Korean%20webtoon%20style%20illustration%20of%20a%20beautiful%20witch%20woman%20with%20long%20silver%20hair%20and%20piercing%20eyes%2C%20wearing%20a%20modern%20black%20dress%2C%20holding%20a%20glowing%20crystal%20orb%2C%20magical%20runes%20floating%20in%20the%20air%2C%20dark%20forest%20background%20with%20fireflies%2C%20enchanting%20and%20dark%20atmosphere&width=600&height=800&seq=comic-cover-16&orientation=portrait',
    description: '17岁的少女白露在生日那天发现自己是一个魔女。按照家族的规定，她必须在一年内找到一个愿意为她献出灵魂的人类，否则她将失去所有魔力变成一个普通人。然而当她遇到那个命中注定的人时，她却犹豫了——她不想让他为自己牺牲。',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['魔女', '校园', '爱情', '抉择'],
    status: '连载中',
    rating: 9.3,
    views: 950000,
    favorites: 41200,
    updatedAt: '2026-08-04',
    chapters: Array.from({ length: 59 }, (_, i) => ({
      id: `ch-16-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      createdAt: new Date(2025, 6, 1 + i * 3).toISOString().split('T')[0],
      imageCount: 40 + Math.floor(Math.random() * 16),
    })),
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
  {
    id: 'comic-17',
    title: '热血足球少年',
    author: '李世勋',
    cover: 'https://readdy.ai/api/search-image?query=A%20dynamic%20sports%20Korean%20webtoon%20style%20illustration%20of%20a%20teenage%20soccer%20player%20mid-kick%20on%20a%20sunlit%20field%2C%20wearing%20a%20red%20jersey%2C%20sweat%20flying%2C%20determined%20expression%2C%20stadium%20crowd%20in%20the%20blurred%20background%2C%20intense%20and%20energetic%20atmosphere%2C%20bright%20sunlight%2C%20vibrant%20green%20field&width=600&height=800&seq=comic-cover-17&orientation=portrait',
    description: '因为身高太矮而被校队拒绝的洪小天不肯放弃足球梦想。他每天苦练到深夜，终于在地区选拔赛上遇到了改变他命运的教练。从此，他和一群同样被看轻的队友们，向着全国大赛的目标发起冲击！',
    category: '热血',
    categorySlug: 'shonen',
    tags: ['足球', '青春', '热血', '竞技'],
    status: '连载中',
    rating: 9.4,
    views: 1130000,
    favorites: 50100,
    updatedAt: '2026-08-03',
    chapters: Array.from({ length: 76 }, (_, i) => ({
      id: `ch-17-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      createdAt: new Date(2025, 2, 1 + i * 3).toISOString().split('T')[0],
      imageCount: 42 + Math.floor(Math.random() * 18),
    })),
    isHot: false,
    isNew: false,
    isRecommended: false,
  },
  {
    id: 'comic-18',
    title: '消失的她',
    author: '韩秀贤',
    cover: 'https://readdy.ai/api/search-image?query=A%20suspenseful%20Korean%20webtoon%20style%20illustration%20of%20a%20woman%20silhouette%20vanishing%20into%20mist%2C%20a%20man%20reaching%20out%20desperately%2C%20dark%20rainy%20alley%2C%20dim%20streetlamp%2C%20ominous%20and%20tense%20atmosphere%2C%20foggy%20and%20mysterious%2C%20muted%20blue%20and%20gray%20tones&width=600&height=800&seq=comic-cover-18&orientation=portrait',
    description: '结婚五年的妻子在某天早上出门后，再也没有回来。丈夫张明浩报了警，但警方查到的信息让他毛骨悚然——他的妻子，在五年前就已经去世了。那么这五年和他一起生活的人到底是谁？真相一层层揭开，比想象中更加令人不寒而栗。',
    category: '悬疑',
    categorySlug: 'mystery',
    tags: ['悬疑', '惊悚', '婚姻', '反转'],
    status: '连载中',
    rating: 9.6,
    views: 1670000,
    favorites: 72300,
    updatedAt: '2026-08-04',
    chapters: Array.from({ length: 42 }, (_, i) => ({
      id: `ch-18-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      createdAt: new Date(2025, 9, 1 + i * 4).toISOString().split('T')[0],
      imageCount: 47 + Math.floor(Math.random() * 20),
    })),
    isHot: true,
    isNew: true,
    isRecommended: true,
  },
  {
    id: 'comic-19',
    title: '皇后娘娘要休夫',
    author: '崔秀晶',
    cover: 'https://readdy.ai/api/search-image?query=A%20gorgeous%20Korean%20webtoon%20style%20illustration%20of%20a%20queen%20in%20magnificent%20traditional%20hanbok%20and%20royal%20headdress%2C%20with%20a%20defiant%20expression%2C%20holding%20a%20scroll%2C%20standing%20in%20a%20grand%20palace%20hall%20with%20ornate%20decorations%2C%20golden%20and%20crimson%20color%20scheme%2C%20regal%20and%20dramatic%20atmosphere&width=600&height=800&seq=comic-cover-19&orientation=portrait',
    description: '穿越到古代成为皇后的现代女性林悦，看着后宫三千佳丽和冷冰冰的皇帝老公，决定潇洒休夫。但这个皇帝好像跟她想象的不太一样——每天变着花样来撩她是怎么回事？古代版"追妻火葬场"，笑点密集停不下来！',
    category: '搞笑',
    categorySlug: 'comedy',
    tags: ['穿越', '宫斗', '搞笑', '甜宠'],
    status: '连载中',
    rating: 9.1,
    views: 1450000,
    favorites: 58900,
    updatedAt: '2026-08-03',
    chapters: Array.from({ length: 69 }, (_, i) => ({
      id: `ch-19-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      createdAt: new Date(2025, 4, 1 + i * 3).toISOString().split('T')[0],
      imageCount: 38 + Math.floor(Math.random() * 15),
    })),
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 'comic-20',
    title: '电竞之王',
    author: '金俊秀',
    cover: 'https://readdy.ai/api/search-image?query=A%20futuristic%20Korean%20webtoon%20style%20illustration%20of%20a%20young%20esports%20gamer%20wearing%20a%20team%20jersey%20and%20high-tech%20headset%2C%20intensely%20focused%2C%20holographic%20game%20interface%20floating%20around%2C%20dark%20background%20with%20colorful%20LED%20lights%2C%20competitive%20gaming%20arena%20atmosphere%2C%20dynamic%20cyberpunk%20aesthetic&width=600&height=800&seq=comic-cover-20&orientation=portrait',
    description: '曾被质疑"玩游戏没出息"的秦飞，用实力证明了自己。从网吧少年到世界冠军，他用五年时间走完了别人十年的路。然而当他站在巅峰时，却发现真正的挑战才刚刚开始——一个更加强大的对手正在等待着他。',
    category: '热血',
    categorySlug: 'shonen',
    tags: ['电竞', '竞技', '逆袭', '友情'],
    status: '连载中',
    rating: 9.5,
    views: 2010000,
    favorites: 83400,
    updatedAt: '2026-08-02',
    chapters: Array.from({ length: 105 }, (_, i) => ({
      id: `ch-20-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      createdAt: new Date(2025, 0, 1 + i * 3).toISOString().split('T')[0],
      imageCount: 43 + Math.floor(Math.random() * 19),
    })),
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
];

export const hotComics = comics.filter((c) => c.isHot);
export const newComics = comics.filter((c) => c.isNew);
export const recommendedComics = comics.filter((c) => c.isRecommended);
export const completedComics = comics.filter((c) => c.status === '已完结');

export function getComicsByCategory(slug: string): Comic[] {
  return comics.filter((c) => c.categorySlug === slug);
}

export function getComicById(id: string): Comic | undefined {
  return comics.find((c) => c.id === id);
}

export function getCategoryBySlug(slug: string) {
  return categories.find((c) => c.slug === slug);
}